<template src="./html/Edit.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'

	export default {
		props: ['user', 'isAuth', 'item'],
		data () {
			return {
				modal: {
					selector: 'modal-edit'
				},
				types: [
					'Imprevisto',
					'Baja',
					'Vacaciones',
				],
				data: null,

				date: {
					start: null,
					end: null,
				}
			}
		},
		watch: {
			'data.start_date': function() {
				this.checkUserHasSchedules()
			},
			'data.end_date': function() {
				this.checkUserHasSchedules()
			},
		},
		computed: {
			isSame: function () {
				var start = moment(this.data.start_date)
				var end = moment(this.data.end_date)

				if(start.isValid() && end.isValid()) {
					return start.isSame(end)
				}
			},
		},
		methods: {
			open(data) {
				this.parseData(data)
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
				this.checkUserHasSchedules()
			},
			parseData(data) {
				this.data = data
				this.data.start_date = moment(data.start_date).toISOString()
				this.data.end_date = moment(data.end_date).toISOString()
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			update() {
				this.formatData()
				if(this.validDates()) {
					var loading = Ladda.create(this.$refs.btnUpdate)
					loading.start()

					this.$http.put('admin/unavailable/' + this.data.id, this.data)
					.then(response => {
						loading.stop()
						this.close()
						this.$emit('reload')
						swal({
							title: response.body.title,
							text: response.body.text,
							type: response.body.type,
						})
					})
				} else {
					swal({
						title: 'Error',
						text: this.$t("messages.the_dates_are_incorrect"),
						type: "warning",
					})
				}
			},
			validDates() {
				var start = moment(this.data.start_date)
				var end = moment(this.data.end_date)

				if(start.isValid() && end.isValid()) {
					return true
				} else {
					return false
				}
			},
			checkUserHasSchedules() {
				var start_date = this.data.start_date
				var end_date = this.data.end_date

				var tasks = this.item.tasks

				if(tasks) {
					for (var i = 0; i < tasks.length; i++) {
						var task = tasks[i]
						var schedules = task.schedules
						if(schedules.length) {
							for (var k = 0; k < schedules.length; k++) {
								var element = schedules[k]

								var start = moment(element.estimated_start)
								var end = moment(element.estimated_end)

								var start_date = moment(start_date)
								var end_date = moment(end_date)

								var betweenStart = start.isBetween(start_date, end_date)
								var isSameStart = start.isSame(start_date)
								var betweenEnd = end.isBetween(start_date, end_date)
								var isSameEnd = end.isSame(end_date)

								if(betweenStart || betweenEnd || isSameStart || isSameEnd) {
									swal(
										this.$t("messages.attention"),
										this.$t("messages.staff_has_tasks_on_dates"),
										'warning'
									)
								} else {
									var betweenStart = start_date.isBetween(start, end)
									var betweenEnd = end_date.isBetween(start, end)

									if(betweenStart || betweenEnd) {
										swal(
											this.$t("messages.attention"),
											this.$t("messages.staff_has_tasks_on_dates"),
											'warning'
										)
									}
								}
							}
						}
					}
				}
			},
			formatData() {
				if(this.data.start_date) {
					var start_date = moment(this.data.start_date)
					this.data.start_date = start_date.format('YYYY-MM-DD H:mm:ss')
				}
				if(this.data.end_date) {
					var end_date = moment(this.data.end_date)
					this.data.end_date = end_date.format('YYYY-MM-DD H:mm:ss')
				}
			},
		}
	}
</script>

<style>
	#textarea-comment {
		padding: 5px;
		font-size: 16px;
	}
</style>


// WEBPACK FOOTER //
// src/components/projects/availability/views/Edit.vue